import printing from '../../../../img/photo-services/printing.jpg';
import passport_photo from '../../../../img/photo-services/passport_photo.jpg';
import retouching from '../../../../img/photo-services/retouching.jpg';
import negatives from '../../../../img/photo-services/negatives.jpg';
import resize from '../../../../img/photo-services/resize.jpg';
import scanning from '../../../../img/photo-services/scanning.jpg';
import { useSetRecoilState } from 'recoil';
import { sidebarOpenState, SidebarType, sidebarTypeState } from '../../../../state/home/sidebar';
import { popupOpenState, PopupType, popupTypeState } from '../../../../state/home/popup';
import TextButton from '../../../common/TextButton';

interface PhotoService {
    title: string;
    image: string;
    description: React.ReactNode;
    price?: string;
    priceOnClick?: () => void;
}

function getPhotoServices(): PhotoService[] {
    const setSidebarType = useSetRecoilState(sidebarTypeState);
    const setSidebarOpen = useSetRecoilState(sidebarOpenState);

    const setPopupType = useSetRecoilState(popupTypeState);
    const setPopupOpen = useSetRecoilState(popupOpenState);

    return [
        {
            title: 'Utskrift',
            image: printing,
            description: 'Utskrift av bilder fra mobil, e-post, minnekort, minnepenn og CD.',
            priceOnClick: () => {
                setSidebarType(SidebarType.PriceList);
                setSidebarOpen(true);
            }
        },
        {
            title: 'Passfoto',
            image: passport_photo,
            description: 'Passbilder til nødpass, visum, ledsagerbevis, bankkort m.m.',
            price: 'Kr 250,-'
        },
        {
            title: 'Lysbilder, negativer og glassplater',
            image: negatives,
            description: 'Digitalisering av lysbilder, negativer og glassplater.',
            price: 'Pris etter avtale'
        },
        {
            title: 'Forstørring',
            image: resize,
            description: 'Forstørring av bilder opp til A3-format.',
            priceOnClick: () => {
                setSidebarType(SidebarType.PriceList);
                setSidebarOpen(true);
            }
        },
        {
            title: 'Skanning',
            image: scanning,
            description: 'Digitalisering av papirbilder, både gamle og nye.',
            price: 'Kr 65,- pr. stk'
        },
        {
            title: 'Retusjering',
            image: retouching,
            description: (
                <>
                    Reparasjon av bretter, riper, flekker og andre skader. Se{' '}
                    <TextButton
                        onClick={() => {
                            setPopupType(PopupType.RetouchingExamples);
                            setPopupOpen(true);
                        }}
                    >
                        eksempler
                    </TextButton>
                    .
                </>
            ),
            price: 'Pris etter avtale, fra kr 75,-'
        }
    ];
}

export default getPhotoServices;
